import { render, staticRenderFns } from "./SzechenyiProgramirodaInformation.vue?vue&type=template&id=165ebac0&scoped=true"
import script from "./SzechenyiProgramirodaInformation.vue?vue&type=script&lang=js"
export * from "./SzechenyiProgramirodaInformation.vue?vue&type=script&lang=js"
import style0 from "./SzechenyiProgramirodaInformation.vue?vue&type=style&index=0&id=165ebac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ebac0",
  null
  
)

export default component.exports